import { render, staticRenderFns } from "./AdminPrice.vue?vue&type=template&id=bd39a2e8"
import script from "./AdminPrice.vue?vue&type=script&lang=js"
export * from "./AdminPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports